import React, { Component } from "react";
import { Button, Alert } from 'react-bootstrap'

import AceEditor from "react-ace";

import "brace/mode/json";
import "brace/theme/github";

import ReferenceService from '../utils/ReferenceService'

class AdminReferenceData extends Component {
  constructor(props) {
    super(props);
    this.state = { errors: [] };
  }

  componentDidMount() {
    this.setState({ loadingInProgress: true });
    ReferenceService.get(this.props.type).then(data => {
      this.setConfig(data)
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.type !== prevProps.type) {
      ReferenceService.get(this.props.type).then(data => {
        this.setConfig(data)
      });
    }
  }

  setConfig(config) {
    this.setState({ loadingInProgress: false, taskConfig: JSON.stringify(config, null, "\t"), validJson: true, dirty: false })
  }

  hideAlert() { this.setState({showAlert: false}) }
  notifySaved() {
    this.setState({ showAlert: true, alertMessage: 'Changes saved', alertStyle: 'success', errors: [] })
    setTimeout(() => { this.hideAlert(); }, 2000);
  }
  notifyErrors(errors) {
    this.setState({ showAlert: true, alertMessage: 'There were some errors', alertStyle: 'danger', errors: errors })
    setTimeout(() => { this.hideAlert(); }, 3000);
  }

  onChange(newValue) {
    this.setState({ taskConfig: newValue,  dirty: true })
    try {
      JSON.parse(newValue)
      this.setState({ validJson: true })
    } catch (e) {
      this.setState({ validJson: false })
    }
  }

  handleClick() {
    this.setState({ saving: true })
    ReferenceService.update(this.props.type, this.state.taskConfig).then(data => {
      this.setState({ saving: false })
      if (data.valid) {
        this.setConfig(data.config)
        this.notifySaved()
      } else {
        this.notifyErrors(data.errors)
      }
    })
  }

  render() {
    return (
      <div>
        <h3 className="first-title">Admin - {this.props.title}</h3>

        <ul>
          {this.state.errors.map((e, i) => (<li key={i} className='text-danger'>{e}</li>))}
        </ul>
        <div className="row">
          <div className="col-sm-12">
            <AceEditor
              mode="json"
              theme="github"
              value={this.state.taskConfig}
              onChange={ (raw)=>{ this.onChange(raw) } }
              name="UNIQUE_ID_OF_DIV"
              width="100%"
              height='70vh'
              tabSize={2}
              editorProps={{ $blockScrolling: true }}
            />
          </div>
        </div>

        <div className="row" style={{marginTop:'20px'}}>
          <div className="col-sm-12">
            <Button
              bsStyle="success"
              bsSize="xsmall"
              disabled={(!this.state.validJson)}
              onClick={this.state.validJson ? (raw)=>{ this.handleClick(raw) } : null}>
              Save Changes
            </Button>
          </div>
        </div>

        { this.state.showAlert
          ? <Alert style={{position:'absolute',bottom:'0',right:'10px',width:'200px'}} bsStyle={this.state.alertStyle} onDismiss={(raw)=>{ this.hideAlert(raw) }}>
              <p>{this.state.alertMessage}</p>
            </Alert>
          : <span></span>
        }
      </div>
    );
  }
}
export default AdminReferenceData;
